export default class StaticPromise{
    static of<T>(value:T): Promise<T>{
        return new Promise((resolve,reject)=>{
            resolve(value);
        })
    }
    static from<T>(resolveValue:()=>T): Promise<T>{
        return new Promise((resolve,reject)=>{
            resolve(resolveValue());
        })
    }
}
